const FooterData = {
  CompanyWidget: [
    {
      id: 1,
      title: "Get In Touch",
      description:
        "Jstechno solutions Pvt. Ltd. is a professional application, software and website development company based in Ahmedabad, India that endeavors on highly proficient , timely delivered and cost effective services.",
    },
  ],
  AboutWidget: [
    {
      id: 1,
      title: "Download",
      menuItems: [
        {
          id: 1,
          url: "#",
          text: "Company",
        },
        {
          id: 2,
          url: "#",
          text: "Android App",
        },
        {
          id: 3,
          url: "#",
          text: "ios App",
        },
        {
          id: 4,
          url: "#",
          text: "Desktop",
        },
        {
          id: 5,
          url: "#",
          text: "Projects",
        },
        {
          id: 6,
          url: "#",
          text: "My tasks",
        },
      ],
    },
    {
      id: 2,
      title: "Help",
      menuItems: [
        {
          id: 1,
          url: "#",
          text: "FAQ",
        },
        {
          id: 2,
          url: "#",
          text: "Term & conditions",
        },
        {
          id: 3,
          url: "#",
          text: "Reporting",
        },
        {
          id: 4,
          url: "#",
          text: "Documentation",
        },
        {
          id: 5,
          url: "#",
          text: "Support Policy",
        },
        {
          id: 6,
          url: "#",
          text: "Privacy",
        },
      ],
    },
  ],
  termsCondition: [
    {
      id: 1,
      title: "Team Solutions",
      menuItems: [
        {
          id: 1,
          url: "#",
          text: "Support",
        },
        {
          id: 2,
          url: "#",
          text: "Sales",
        },
        {
          id: 3,
          url: "#",
          text: "Report Abuse",
        },
        {
          id: 4,
          url: "#",
          text: "System Status",
        },
      ],
    },
  ],
  SocialLinks: [
    {
      id: 1,
      title: "Team Solutions",
      menuItems: [
        {
          id: 1,
          url: "https://in.linkedin.com/company/jstechno",
          icon: "ti-facebook",
        },
        {
          id: 2,
          url: "#",
          icon: "ti-twitter-alt",
        },
        {
          id: 3,
          url: "#",
          icon: "ti-linkedin",
        },
        {
          id: 4,
          url: "#",
          icon: "fa fa-google",
        },
      ],
    },
  ],
  socialIcon: [
    {
      id: 1,
      url: "https://www.facebook.com/jstechno/",
      icon: "Social_facebook.svg",
    },
    {
      id: 2,
      url: "https://twitter.com/jstechno",
      icon: "Social_twitter.svg",
    },
    {
      id: 3,
      url: "https://in.linkedin.com/company/jstechno",
      icon: "Social_linkedin.svg",
    },
    {
      id: 4,
      url:
        "https://www.google.com/search?q=jstechno&sz=0&tbm=lcl&sxsrf=ALiCzsb2fAPnASqNNYrGjyzK7OO7nQmv-w%3A1654771444225&ei=9M6hYt-fDaO22roPjL-xkA4&oq=jstechno&gs_l=psy-ab.3...3247.3399.0.3592.2.2.0.0.0.0.0.0..0.0....0...1c.1.64.psy-ab..2.0.0....0.iy3QSk6G1QE",
      icon: "Social_google.svg",
    },
    {
      id: 5,
      url: "mailto:Info@jstechno.com",
      icon: "Social_mail.svg",
    },
    {
      id: 6,
      url: "https://www.instagram.com/jstechno/?hl=en",
      icon: "Social_instagram.svg",
    },
  ],
  copywrite: "© Jstechno Solutions Pvt. Ltd. 2016 All rights reserved.",
  HomeTestimonial: [
    {
      id: 1,
      image: "fnflogo.png",
      title: `I am very impressed by the quality of the team working on our project. Not only is the code top quality which many development houses can write but the team displays a real understanding of our issues and comes to the table with suggestions and ideas that are very impressive. They never “just accept” what we tell them,they always question if what we are suggesting is the best way to approach the problem. This has led to a better overall product, and one that we are very confident in moving forward.`,
      meta_title: "FRESH  N  FRESH",
      // meta_description: "7oroof Inc",
    },
    {
      id: 2,
      image: "daslogo.png",
      title: `We are very satisfied and happy to have found JS Techno as our software development . During our relationship, Js Techno has developed a good understanding of our own vision and work flows and found a way to successfully complement our operations without causing any discontinuities or issues on our side.`,
      meta_title: "DAS MULTI SERVICE PVT LTD",
      // meta_description: "web Inc",
    },
    {
      id: 3,
      image: "vanvetlogo.png",
      title: `We have been running Client Control for over two years and have not had a single problem. Let me stress this point, we have not had any problems. The product has continued to pay for itself throughout its life cycle, from client deployment and server setup to day-to-day functionality and server fault tolerance.`,
      meta_title: "VANVET PVT LTD.",
      // meta_description: "web Inc",
    },
  ],
  TestimonialText: [
    {
      id: 1,
      image: "new/member_01.jpg",
      description:
        "He nicked it hanky panky Eaton naff it's your round quaint cheeky cheers, tomfoolery bonnet posh blimey what a plonker vagabond, zonked Elizabeth give us a bell.?",
      authorName: "Phillip Anthropy",
      authorPost: "UI/UX designer",
    },
    {
      id: 2,
      image: "new/member_01.jpg",
      description:
        "He nicked it hanky panky Eaton naff it's your round quaint cheeky cheers, tomfoolery bonnet posh blimey what a plonker vagabond, zonked Elizabeth give us a bell.?",
      authorName: "Phillip Anthropy",
      authorPost: "UI/UX designer",
    },
    {
      id: 3,
      image: "new/member_01.jpg",
      description:
        "He nicked it hanky panky Eaton naff it's your round quaint cheeky cheers, tomfoolery bonnet posh blimey what a plonker vagabond, zonked Elizabeth give us a bell.?",
      authorName: "Phillip Anthropy",
      authorPost: "UI/UX designer",
    },
    {
      id: 4,
      image: "new/member_01.jpg",
      description:
        "He nicked it hanky panky Eaton naff it's your round quaint cheeky cheers, tomfoolery bonnet posh blimey what a plonker vagabond, zonked Elizabeth give us a bell.?",
      authorName: "Phillip Anthropy",
      authorPost: "UI/UX designer",
    },
  ],
  aboutLinks: [
    {
      id: 1,
      url: "#",
      item: "Developer",
    },
    {
      id: 2,
      url: "/blog",
      item: "Blog",
    },
    {
      id: 3,
      url: "#",
      item: "Investor",
    },
    {
      id: 4,
      url: "#",
      item: "Sitemap",
    },
    {
      id: 5,
      url: "#",
      item: "Jobs",
    },
  ],
  helpLinks: [
    {
      id: 1,
      url: "#",
      item: "Help and Contact",
    },
    {
      id: 2,
      url: "#",
      item: "Fees",
    },
    {
      id: 3,
      url: "#",
      item: "Security",
    },
    {
      id: 4,
      url: "#",
      item: "App",
    },
    {
      id: 5,
      url: "#",
      item: "Shop",
    },
  ],
  PrivacyLinks: [
    {
      id: 1,
      url: "#",
      item: "Privacy Policy",
    },
    {
      id: 2,
      url: "#",
      item: "Legal Agreement",
    },
    {
      id: 3,
      url: "#",
      item: "Feedback",
    },
  ],
  about: [
    {
      id: 1,
      url: "#",
      text: "Company",
    },
    {
      id: 2,
      url: "#",
      text: "Leadership",
    },
    {
      id: 3,
      url: "#",
      text: "Diversity",
    },
    {
      id: 4,
      url: "#",
      text: "Jobs",
    },
    {
      id: 5,
      url: "#",
      text: "Press",
    },
    {
      id: 6,
      url: "#",
      text: "Wavelength",
    },
  ],
  Solution: [
    {
      id: 1,
      url: "#",
      text: "Project Management",
    },
    {
      id: 2,
      url: "#",
      text: "Agile",
    },
    {
      id: 3,
      url: "#",
      text: "Task Management",
    },
    {
      id: 4,
      url: "#",
      text: "Reporting",
    },
    {
      id: 5,
      url: "#",
      text: "Work Tracking",
    },
    {
      id: 6,
      url: "#",
      text: "See All Uses",
    },
  ],
  teamSolution: [
    {
      id: 1,
      url: "#",
      text: "Engineering",
    },
    {
      id: 2,
      url: "#",
      text: "Designers",
    },
    {
      id: 3,
      url: "#",
      text: "Sales",
    },
    {
      id: 4,
      url: "#",
      text: "Developers",
    },
    {
      id: 5,
      url: "#",
      text: "Marketing",
    },
    {
      id: 6,
      url: "#",
      text: "See All team",
    },
  ],
};
export default FooterData;
